// extracted by mini-css-extract-plugin
module.exports = {"jds-Illustration--big":"Illustration_jds-Illustration--big__I2Ypf","jds-Illustration--small":"Illustration_jds-Illustration--small__QCVX_"};